var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorWashLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.07 50.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#309545;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.25,13.17H13.54c10.21,0,12.69,5.29,12.69,14.22V45.83c0,7.35-1.26,15.44-12.7,15.44H3.25ZM10.67,55h2.38c4.88,0,5.63-3.14,5.63-8.12v-20c0-4.42-.78-7.25-5.67-7.25H10.67Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.73,35.44V49.77c0,8-4,12.08-11,12.08-7.26,0-10.85-4.2-10.85-12V35.14c0-8.07,4.59-11.72,11.07-11.72C48.69,23.42,52.73,27.57,52.73,35.44ZM38.31,35V50.08c0,3,.91,5.2,3.56,5.2,2.48,0,3.43-1.84,3.43-5.33V35c0-2.88-.77-5-3.49-5C39.39,30,38.31,31.72,38.31,35Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79,35.44V49.77c0,8-4,12.08-11,12.08-7.26,0-10.85-4.2-10.85-12V35.14c0-8.07,4.59-11.72,11.07-11.72C75,23.42,79,27.57,79,35.44ZM64.59,35V50.08c0,3,.91,5.2,3.56,5.2,2.47,0,3.43-1.84,3.43-5.33V35c0-2.88-.77-5-3.49-5C65.67,30,64.59,31.72,64.59,35Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.17,36.63c0-6.19.07-8.82-.07-12.63h7c.07.72.21,4,.21,6,1.47-5,4.75-6.58,8.21-6.6v9.15c-4.25,0-8,1.08-8,8.72v20H84.17Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.11,61.27l-6.59-48.1h7.89c1.11,10.38,2.59,26.34,3,35.42h.14c1.1-10.18,3.11-24.88,4.48-35.42h7.21c1.43,10.89,3.43,24.48,4.41,35.09h.15c.57-9.39,2-24.19,3.09-35.09h7.5l-7.11,48.1h-7.57c-1.36-10.78-3.24-23.61-4.27-33.51h-.13c-1.12,10.11-3.22,23.14-4.66,33.51Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.17,53.64c0,2.35,0,6.21.14,7.63h-6.78c-.15-.7-.41-2.2-.47-2.73-1.27,2.28-3.29,3.31-6.15,3.31C142.3,61.85,140,56.66,140,51v-.65c0-9.18,6.19-11.62,12.91-11.62h.85V34c0-2.92-.35-4.56-2.61-4.56s-2.7,1.71-2.7,4v.61H141.2V33.6c0-5.4,2.07-10.18,10.26-10.18,7.19,0,9.71,4,9.71,10Zm-7.23-9.26H152.7c-3.38,0-5.61,1.28-5.61,5.92v.59c0,2.63.95,4.5,3.27,4.5,2.48,0,3.58-1.72,3.58-6.74Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173,49.61v1.7c0,2.3.64,4.29,3,4.29,2,0,2.88-1.23,2.88-3.71s-.68-4.07-5.2-7c-5.12-3.3-7.59-6-7.59-11.33,0-6.3,3.38-10.16,9.87-10.16,7,0,9.85,3.89,9.85,10.72v1.49h-7.17v-2.3c0-2.59-.87-3.65-2.63-3.65S173.45,31,173.45,33s.7,3,4.09,5.21c6.52,4.14,8.83,6.78,8.83,12.89,0,7.13-3.58,10.78-10.59,10.78-8.37,0-10.29-5.27-10.29-10.59V49.61Z",
    transform: "translate(-3.25 -11.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.93,11.07v16c1.17-2.15,3.27-3.66,6.93-3.66,5.7,0,7.46,4.28,7.46,9.6V61.27h-7.41V35c0-2.75-.55-4.92-3.27-4.92-2.89,0-3.71,1.9-3.71,6.16v25h-7.41V11.07Z",
    transform: "translate(-3.25 -11.07)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorWashLogo);
export default __webpack_public_path__ + "static/media/DoorWashLogo.36861520d13312c5ef83091d8873b746.svg";
export { ForwardRef as ReactComponent };